export default __webpack_public_path__ + "861e2ac4425b3ed1bb9f0a0535eeaab1.svg";